<template>
  <div class="card custom_list">
    <div class="custom_list__header">
      <h4 class="title">
        {{ type === "device" ? translate('custom.add_device_in_list') : translate('custom.connect_user_to_list') }}
      </h4>
    </div>

    <div class="custom_list__content">
      <div class="new_device" v-if="type === 'device'">
        <fg-input
          v-model="new_device"
          class="name"
          type="text"
          :label="translate('custom.enter_device')"
          :placeholder="translate('custom.enter_device')"
        />
      </div>

      <div class="new_device" v-else>
        <label>
          {{ translate('custom.enter_user') }}
        </label>
        <div>
          <fg-input
              v-model="new_user_name"
              class="name"
              type="text"
              :placeholder="translate('custom.enter_user_login')"
              :disabled="new_user_ids.length > 0"
          />
        </div>

        <div>
          <tree-select
              :max-height="200"
              :options="company_user_list"
              :multiple="true"
              v-model="new_user_ids"
              :placeholder="translate('custom.select_user_login')"
              :clearable="true"
              :disabled="new_user_name !== ''"
          />
        </div>
      </div>
    </div>


    <div class="custom_list__button">
      <button
        class="btn btn-success btn-fill btn-wd"
        @click.prevent="save"
      >
        {{ translate('save') }}
      </button>
      <button
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

export default {
  name: "AddToList",
  props: ["list_id", "type", "connected_users"],

  data () {
    return {
      new_device: "",
      new_user_name: "",
      new_user_ids: []
    }
  },

  computed:{
    company_user_list(){
      return this.$store.getters.getCompanyUserList.map((user) => {
        if (this.connected_users_ids.indexOf(user.id) === -1){
          return {label: user.name, id: user.id}
        }
      }).filter((element) => { return element !== undefined })
    },
    connected_users_ids(){
      return this.connected_users.map((user) => {
        return user.user_id
      })
    }
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    save () {
      if (this.type === "device") {
        let list = {
          "device_list_id": this.list_id,
          "device_ids": [],
          "device_fids": [this.new_device]
        }
        this.$http.v1.addDevicesCustomDeviceList(list,  (response) => {
          this.global_notify('info', this.translate('custom.add_devices_success'))
          this.$store.dispatch('customListUpdate')
          this.$emit('close')
        }, (bad_answer) =>{
          this.global_notify('danger', this.translate('custom.add_devices_error'))
        })
      }else{
        let list = {
          "device_list_id": this.list_id
        }
        this.new_user_name !== "" ? list.user_name = this.new_user_name : ""
        this.new_user_ids.length > 0 ? list.user_ids = this.new_user_ids : ""

        this.$http.v1.addUserCustomDeviceList(list, () => {
          this.global_notify('info', this.translate('custom.add_user_success'))
          this.$store.dispatch('customListUpdate')
          this.$emit('close')
        })
      }

    },

  }
}

</script>

<style lang='scss' scoped>

  .custom_list{
    &__header{
      padding: 20px 10px 10px;
      .title{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }
    }
    &__content{
      padding: 10px;
      height: 300px;
      textarea{
        flex: 10;
        width: 100%;
        height: 100%;
        overflow: auto;
        outline: none;
        &::-webkit-scrollbar {
          width: 10px;
        }
      }
    }
    &__button{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
      }
    }
  }
  @media (max-width:600px) {
    .custom_list{
      &__form{
        &-row{
          flex-direction: column;
          &__input{
            width: 100%;
          }
        }
      }
    }
  }

</style>
